// ie polyfill
import '@babel/polyfill'
import hl from 'highlight.js'
import 'highlight.js/styles/a11y-dark.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'
import { ACCESS_TOKEN, USERID } from './store/mutation-types'

// mock
// import './mock'
import bootstrap from './core/bootstrap'
import './core/use'
import './permission' // permission control
import './utils/filter' // global filter
import base from './base'
// 必须放在所有组件/antd 样式之后，才能覆盖按需加载出来的默认样式
import './assets/tech-theme.css'
Vue.config.productionTip = false
// 自定义一个代码高亮指令
Vue.directive('highlight', function (el) {
  const blocks = el.querySelectorAll('code')
  blocks.forEach((block) => {
    hl.highlightElement(block)
  })
})

// mount axios Vue.$http and this.$http
Vue.use(VueAxios)

Vue.use(base)

// 免登录进入控制台: 从URL参数(或hash内参数)注入登录会话
;(function () {
  const href = window.location.href
  const hashIdx = href.indexOf('#')
  let qs = ''
  if (hashIdx >= 0) {
    const hashPart = href.slice(hashIdx + 1)
    const qIdx = hashPart.indexOf('?')
    if (qIdx >= 0) {
      qs = hashPart.slice(qIdx + 1)
    }
  }
  if (!qs) {
    qs = window.location.search.replace(/^\?/, '')
  }
  const params = new URLSearchParams(qs)
  const token = params.get('access_token')
  const uid = params.get('userid')
  if (token && uid) {
    Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
    Vue.ls.set(USERID, uid, 7 * 24 * 60 * 60 * 1000)
    // 清除URL中的注入参数, 避免刷新后重复注入
    const url = new URL(window.location.href)
    url.searchParams.delete('access_token')
    url.searchParams.delete('userid')
    const hIdx = url.hash.indexOf('?')
    if (hIdx >= 0) {
      const hPath = url.hash.slice(0, hIdx)
      const hParams = new URLSearchParams(url.hash.slice(hIdx + 1))
      hParams.delete('access_token')
      hParams.delete('userid')
      const hs = hParams.toString()
      url.hash = hPath + (hs ? '?' + hs : '')
    }
    window.history.replaceState({}, document.title, url.toString())
  }
})()

new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
